import { Injectable } from '@angular/core';
import { InputEvents, SensorSet, BaseSensor as Sensor, MenuNode, TimeFrame } from '../classes';
import { LogService } from '../services/log.service';
import { TranslationService } from '../services/translation.service';
import { ConfigService } from '../services/config.service';
import { KeyValuePair, TimeFrameManager,ZoneData, DeviceInfo, BaseSensor, ZeitprogrammAssistent } from '../classes';
import { MenuLogic } from '../classes/MenuLogic';
import { MenuLogicSnippets } from '../classes/MenuLogicSnippets';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class DataIoService {

  windowWidth:number=855;
  public _debug = false;
  public _deviceInfo : DeviceInfo;
  
  public warmwasser = new TimeFrameManager();
  public zirkulation = new TimeFrameManager();
  public lueftung = new TimeFrameManager();
  
  public inputs = new InputEvents();
  public currentTime: Date = new Date();
  private serviceDate:Date;
  public timeDiff : number = 0;
  public currentTemperature : number = -12;
  public currentTimeFrame :TimeFrame = null;
  public timeFrameManagers : Array<TimeFrameManager>;
  public values : Map<string,string>;
  public zeitprogrammAssistent:ZeitprogrammAssistent;



  contactPhone:string="";
  contactCompanyName:string="";

  elementFocused$=new Subject<MenuNode>();
  infoTextElement$=new Subject<MenuNode>();

  // selected i.E. highlighted *AND* entered

  onElementFocused():Subject<MenuNode>{
    return this.elementFocused$;
  }
  
  onInfoTextAvailable():Subject<MenuNode>{
    return this.infoTextElement$;
  }
  //
  
  public infoTextAvailable(element:MenuNode){
    this.infoTextElement$.next(element);
  }
  
  elementFocused(element: MenuNode){
    this.elementFocused$.next(element);
  }
  
  public temporaryValues = new Map<string,any>();
  
  set sensors(s: SensorSet){

  }
  get sensors(): SensorSet{
    if(!this.deviceInfo().getDefaultZoneId()){
      let heatingCircuitCount = this.config.simulatorConfig.heatingCircuitCount();
      let heatpumpCount = this.config.simulatorConfig.heatpumpCount();
      let boilerCount = this.config.simulatorConfig.boilerCount();
      this.deviceInfo().setHeatingCircuitCount(heatingCircuitCount);
      this.deviceInfo().setZoneCount(heatingCircuitCount);
      this.deviceInfo().setHeatpumpCount(this.config.simulatorConfig.heatpumpCount());
      this.deviceInfo().setBoilerCount(this.config.simulatorConfig.boilerCount());
    }
    return this.deviceInfo().getZoneById(this.deviceInfo().getDefaultZoneId()).getSensors();
    
  }


  public debug(msg:string):void{
    if(this._debug){
      console.log("DataIoService: "+msg);
    }
  }
  configSubscription:any;

  modulesSetEvent(){
    this.debug("DataIoService: resetting because modules are set.");
    this.reset_members();
    this.afterSetup()
    this.deviceInfo().setSimulatorConfig(this.config.simulatorConfig);
    // die auswahl wurde als SimulatorModulConfig verfügbar
    this.deviceInfo().getHooks().setConfigService(this.config);
    this.debug("setting heating circuits.");
    let heatingCircuitCount = this.config.simulatorConfig.heatingCircuitCount();
    let heatpumpCount = this.config.simulatorConfig.heatpumpCount();
    let boilerCount = this.config.simulatorConfig.boilerCount();
    this.debug("###################################");
    this.debug("Setting heating circuit count to : "+ heatingCircuitCount);
    this.debug("Setting vr71 count to : "+ this.config.simulatorConfig.getVR71Count());
    this.debug("###################################");
    this.deviceInfo().setHeatingCircuitCount(heatingCircuitCount);
    this.deviceInfo().setZoneCount(heatingCircuitCount);
    this.deviceInfo().setHeatpumpCount(this.config.simulatorConfig.heatpumpCount());
    this.deviceInfo().setBoilerCount(this.config.simulatorConfig.boilerCount());
    

    this.insertMenuDependencies();
//    console.log("Reloading menu.");
    this.config.reloadMenu();
    MenuLogic.clear();
    MenuLogicSnippets.run(this);
  }
  setup(){
    MenuLogic.setIoService(this);
    this.debug("DataIoService: setup()");
    this.configSubscription = this.config.simulatorConfig.events$.subscribe(
      (event)=>{
        if(event == 'modules_set'){
          this.modulesSetEvent();
        }
    },
    (error)=>{

    }
    );
    console.log("Setting new DeviceInfo. 2");
    this._deviceInfo = new DeviceInfo();

    
    this.zeitprogrammAssistent = new ZeitprogrammAssistent(0);
    this.zeitprogrammAssistent.setIoService(this);
    this.setupClock();
    this.debug("Constructing inputEvents.");
    this.inputs = new InputEvents();
    this.debug("subscribing to input-events.");
    this.values = new Map<string,string>();
    
    this.updateCurrentTime();
    this.inputs.events$.subscribe((data)=>{
      //this.debug("Data from inputs: "+data);
    });
    this.serviceDate = new Date();
    this.serviceDate.setMonth(0);
    this.serviceDate.setFullYear(this.serviceDate.getFullYear()+1);
    this.debug("SERIVCEDATE: "+this.serviceDate);
  }
  translatorSubscription:any;
  constructor(private log: LogService, private config: ConfigService,private translator:TranslationService) { 
    this.debug("Constructing.");
    MenuNode.setDataIoService(this);
    MenuLogic.setIoService(this);
    MenuNode.setTranslator(translator);
    console.log("Setting new DeviceInfo. 3");
    this._deviceInfo = new DeviceInfo();
    this.debug("DataIoService: Waiting with setup until dictionary is available.");
    this.setup();
    this.config.events$.subscribe(
      (event)=>{
        if(event == 'completed'){
          this.debug("MENU COMPLETED");
          //MenuLogic.clear();
          //MenuLogicSnippets.run(this);
        
          this.debug("Deferred setup running.");
          
          //this.translatorSubscription.unsubscribe();
        }
      }
    )
    
    
    
  }

  getConfiguration(){
    return this.config;
  }
  // werkszustand
  reset(){
//    console.log("resetting.");
    this.getConfiguration().setLanguage('de');
    this.reset_members();
    this.config.reloadMenu();
    MenuLogic.clear();
    MenuLogicSnippets.run(this);
  }
  reset_members(){
    this.debug("RESETTING.");
    this.nodeHistory = new Array<MenuNode>();
    this.debug("Resetting all data.");
    console.log("Setting new DeviceInfo. 1");
    this._deviceInfo = new DeviceInfo();
    this._deviceInfo.setSimulatorConfig(this.config.simulatorConfig);
    this.deviceInfo().setHeatpumpCount(3);
    
    this.zeitprogrammAssistent = new ZeitprogrammAssistent(0);
    this.zeitprogrammAssistent.setIoService(this);

    this.setupClock();
    this.debug("Constructing inputEvents.");
    this.debug("subscribing to input-events.");
    this.values = new Map<string,string>();
    
    this.updateCurrentTime();
    this.serviceDate = new Date();
    this.serviceDate.setMonth(0);
    
    this.serviceDate.setFullYear(this.serviceDate.getFullYear()+1);
    this.config.reloadMenu();
    MenuLogic.clear();
    MenuLogicSnippets.run(this);


  }
  getCurrentNominalTemperatureSensor():Sensor{
    let sensor = this.deviceInfo().getNominalTemperatureSensor(this.getCurrentTime());
    return sensor;
  }
  setValue(key:string,value:string){  
    this.debug("Setting "+key+" to "+value);
    this.values.set(key,value);
  }
  getValue(key:string,_defaultValue?){
    return this.translator.tr(this.getRawValue(key,_defaultValue));
  }
  getRawValue(key:string,_defaultValue?:string){
    this.debug("Getting "+key);
    let value = this.values.get(key);
    if(value){
      return value;
    }
    if(_defaultValue){
      return _defaultValue;
    }
    return undefined;
  }

  getConnectedDevicesList() : Array<KeyValuePair>{
    let list = new Array<KeyValuePair>();
    list.push(new KeyValuePair('SW_VERSION_VRC720','2.13'));
    
    if(this.getConfiguration().simulatorConfig.hasRadio()){
      list.push(new KeyValuePair('SW_VERSION_BASE','2.13'));  
    }

    for(let i = 1; i <= this.deviceInfo().getConfiguredBoilerCount(); i++){
       list.push(new KeyValuePair('SW_VERSION_BOILER'+i.toString(),'06.03'));
    }

    for(let i = 1; i <= this.deviceInfo().getConfiguredHeatpumpCount(); i++){
       list.push(new KeyValuePair('SW_VERSION_HP'+i.toString(),'03.07'));
    }

    if(this.config.simulatorConfig.hasHeatpump()){
       list.push(new KeyValuePair('SW_VERSION_VWZAI','03.07'));
    }

    for(let i = 1; i <= this.deviceInfo().getVR70Count(); i++){
       list.push(new KeyValuePair('SW_VERSION_VR70_'+i.toString(),'01.09'));
    }
    if(this.deviceInfo().getRawValue('remote_connected')=='WIZARD_REMOTE_CONTROLS_OPTION_ENUM1' && this.getConfiguration().simulatorConfig.hasVR71()){
        list.push(new KeyValuePair('SW_VERSION_VR92','04.19'));
    }else{
      if(['de','be'].includes(this.getConfiguration().simulatorConfig.getCountry()) && this.config.simulatorConfig.activeHeatingCircuits() >= 2){
        list.push(new KeyValuePair('SW_VERSION_VR92','04.19'));
      }
    }

    if(this.config.simulatorConfig.hasVR71()){
        list.push(new KeyValuePair('SW_VERSION_VR71','01.09'));
    }  

    for(let i=1; i<=this.config.simulatorConfig.ventilationCount();i++){
        list.push(new KeyValuePair('SW_VERSION_RECOVAIR'+i.toString(),'02.27'));
    }

    for(let i=1;i<= this.config.simulatorConfig.solarCylinderCount();i++){
    }

    if(this.config.simulatorConfig.solarCylinderCount()> 0){
      list.push(new KeyValuePair('SW_VERSION_VMS','03.15')); 
    }
    
    return list;
  }


  setContactName(arg:string){
    this.contactCompanyName = arg;
  }
  getContactName(){
    return this.contactCompanyName;
  }
  setContactPhone(arg:string){
    this.contactPhone = arg;
  }
  getContactPhone(){
    return this.contactPhone;
  }
  getContacts(){
    let dict = new Array<KeyValuePair>();
    dict.push(new KeyValuePair("VIEWER_INSTALLER_PHONE_NUMBER",this.contactPhone));
    dict.push(new KeyValuePair("VIEWER_INSTALLER_NAME",this.contactCompanyName));
    return dict;
  }

  deviceInfo(){
      return this._deviceInfo;
  }
  

  setupClock(){
  	setInterval(() => {
          this.updateCurrentTime();
        }, 1000);
  }

  updateCurrentTime(){
    this.currentTime.setTime((new Date()).getTime()-this.timeDiff);
  }
  upClicked(){
    this.inputs.upClicked();

  }
  downClicked(){
    this.inputs.downClicked();
  }
  menuClicked(){
    this.inputs.menuClicked();
  }
  chimneyClicked(){
    this.inputs.chimneyClicked();
  }
  dhwClicked(){
    this.inputs.dhwClicked();
  }
  heatingClicked(){
    this.inputs.heatingClicked();
  }
  powerClicked(){
    this.inputs.powerClicked();
  }
  backClicked(){
    this.inputs.backClicked();
  }
  questionClicked(){
    this.inputs.questionClicked();
  }
  confirmClicked(){
    this.inputs.confirmClicked();
  }
  panStart(){
    this.inputs.panStart();
  }
  panEnd(){
    this.inputs.panEnd();
  }
  panDown(){
    this.inputs.panDown();
  }
  panUp(){
    this.inputs.panUp();
  }
  setTime(date: Date){
    this.timeDiff= ((new Date()).getTime()-date.getTime());
    this.updateCurrentTime();
  }
  getCurrentTime(){
     return this.currentTime;
  }
  getCurrentTimeFrame():TimeFrame{
    return this.currentTimeFrame;
  }
  setCurrentTimeFrame(frame: TimeFrame){
    this.currentTimeFrame = frame;
  }
  getServiceDate(){
    return this.serviceDate;
  }
  setServiceDate(date: Date){
    this.serviceDate = date;
  }

  getZeitprogrammAssistent(){
    return this.zeitprogrammAssistent;
  }
  getDeviceInfo(){
    return this._deviceInfo;
  }

  getCurrentLanguage() : string{
    return this.config.getCurrentLanguageDefinition().getCountryCode();
  }
  getCurrentLanguageName() : string{
    return this.config.getCurrentLanguageDefinition().getLanguageName();
  }

  getWindowWidth() : number{
    return this.windowWidth;
  }
  setWindowWidth(ww : number) : void{
    this.windowWidth = ww;
  }
  insertMenuDependencies(){
    MenuLogic.clear();
    MenuLogicSnippets.run(this);
  }


  /**
    Node-History
  **/
  
  private nodeHistory = new Array<MenuNode>();
  inHistory(node:MenuNode):boolean{
    return this.nodeHistory.includes(node);
  }
  eraseLastHistoryItem(){
    if(this.nodeHistory.length > 0){
      this.nodeHistory.pop();
    }
  }
  historyPop():MenuNode{
    return this.nodeHistory.pop();
  }

  historyLength():number{
    return this.nodeHistory.length;
  }
  getHistoryItemByIndex(idx: number) : MenuNode{
    return this.nodeHistory[idx];
  }
  historyPush(node:MenuNode){
//    console.log("Pushing to history: "+node.getIdentifier()+"/"+node.getName()+"/"+node.getTitle());
    this.nodeHistory.push(node);
  }
  afterSetup(){
  //  console.log("AFTER SETUP HOOK.");
    this.nodeHistory.length = 0;
    this.nodeHistory.push(MenuNode.getRoot().findRecursive('dashboard'));
  }
  serviceDateExpired(){
    return this.serviceDate.getTime()<this.getCurrentTime().getTime();
  }

  codeResetHandle = undefined;
  startCodeReset(){
    if(this.codeResetHandle){
      this.stopCodeReset();
    }
    this.codeResetHandle = setTimeout(
      ()=>{
        this.deviceInfo().getScale('last_code').setCurrentValue(0); 
        this.stopCodeReset();
      },
      45*1000);
  }
  stopCodeReset(){
    clearTimeout(this.codeResetHandle);
    this.codeResetHandle = undefined;
  }
}


